import { DetailedHTMLProps, ImgHTMLAttributes } from 'react';
import { ResponsiveValue } from '@gousto-internal/citrus-react';
import { getRecipeImageSizes, recipeImageSizes } from '../../utils/image';

type HtmlImageProps = DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export function RecipeImage(
  props: { primaryImageUrl: string; height?: ResponsiveValue<string> } & HtmlImageProps,
) {
  const { primaryImageUrl, ...rest } = props;
  const { srcset, src } = getRecipeImageSizes(primaryImageUrl);

  return (
    <img
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      }}
      srcSet={srcset}
      src={src}
      sizes={recipeImageSizes}
      alt=""
      {...rest}
    />
  );
}
